
<template>
  <div>
    <!-- <div>
      {{info}}
    </div> -->
    <v-row justify="space-around" >
      <v-col cols='5'>
        <v-text-field readonly label="Pago em" :value="info.payed"></v-text-field>
      </v-col>
      <v-col cols='5' v-if="info.confirmed">
        <v-text-field readonly label="Confirmado em" :value="info.confirmed"></v-text-field>
      </v-col>
      <v-col cols='5' v-if="info.confirmed">
        <v-text-field readonly label="Confirmado por" :value="info.confirmed_by"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <!-- <v-text-field readonly label="Depositado em" :value="(new Date(info.deposit_date)).toDateString('pt-BR')"></v-text-field> -->
        <v-text-field readonly label="Depositado em" :value="info.deposit_date_aux"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Banco" :value="info.deposit_bank"></v-text-field>
      </v-col>
      <v-col cols='5'>
        <v-text-field readonly label="Empresa" :value="info.deposit_company"></v-text-field>
      </v-col>
      
      <v-col cols='12' v-if="info.comment">
        <v-textarea hide-details rows='2' readonly label="Comentários" :value="info.comment"></v-textarea>
      </v-col>
      <v-alert class="mb-3" type="warning" :value="true" v-if="info.used_in_problem_delivery">
        Usado para desconto em problemas com entrega!
      </v-alert>
      
    </v-row>
    <v-container grid-list-xl>
      <v-row>
        <v-text-field readonly label="Total"             :value="Number(info.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})"></v-text-field>
        <v-text-field readonly label="A vista"           :value="Number(info.entrance_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" v-if="info.entrance_value"></v-text-field>
        <v-text-field readonly label="1 dia bloqueado"   :value="Number(info.one_day_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" v-if="info.one_day_value"></v-text-field>
        <v-text-field readonly label="2 dias bloqueados" :value="Number(info.two_days_value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})" v-if="info.two_days_value"></v-text-field>
      </v-row>
      <!-- <v-text-field readonly label="Num. Depósito" :value="info.number"></v-text-field> -->
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'InfoDeposit',
  props: {
    info: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>